export default __webpack_public_path__ + "static/media/FnB Banner.de04efdb.jpg";